import { Permissions } from '@/app/types';

interface LobbyDeviceWarningsProps {
  denied: Permissions;
}

const WARNING = 'text-orange-600 dark:text-orange-400 animate-fade-in paragraph-3';

export default function LobbyDeviceWarnings({ denied }: LobbyDeviceWarningsProps) {
  // A customer whose microphone is off can still join — the call is simply
  // one-way until they fix it, and saying so beats a button that only looks
  // broken.
  return (
    <>
      {denied.audio && (
        <p className={WARNING}>Your microphone is off — turn it on so you can be heard.</p>
      )}
      {denied.video && <p className={WARNING}>Your camera is off — turn it on so you can be seen.</p>}
    </>
  );
}
